import React from "react";
import ReportsContainer from "../containers/Reports";

const Reports = () => {
  return <ReportsContainer />;
};

export default Reports;
